import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { LoggedUsersService } from 'src/app/metrics/services/logged-users.service';
import { TaskDetail } from 'src/app/metrics/shared/models';

@Component({
  selector: 'app-dashboard-task-details-dialog',
  templateUrl: './dashboard-task-details-dialog.component.html',
  styleUrls: ['./dashboard-task-details-dialog.component.scss'],
})
export class DashboardTaskDetailsDialogComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = [
    'id',
    'dateOfReceipt',
    'account',
    'channel',
    'url',
    'content',
    'authorId',
    'authorName',
    'dateOfDisplay',
    'team',
  ];
  dataSource: MatTableDataSource<TaskDetail> = new MatTableDataSource([]);
  @ViewChild(MatSort) sort: MatSort;
  headers: TaskDetail;

  constructor(
    public dialogRef: MatDialogRef<DashboardTaskDetailsDialogComponent>,
    private loggedUsersService: LoggedUsersService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.headers = this.data.headers;
    this.dataSource = new MatTableDataSource(this.data.rows);
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  export() {
    this.loggedUsersService.createTaskDetailsExport(this.data.tasks);
  }
}
